"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.Item = exports.SocialMediaLinksRoot = exports.Anchor = exports.Term = exports.RoofProLevelRow = exports.AddressRow = exports.Row = exports.Root = exports.RoofProLevelLogo = exports.List = exports.Link = exports.Details = exports.Description = exports.StyledAddress = void 0;
const styles_1 = require("@mui/material/styles");
const anchor_link_1 = __importDefault(require("../anchor-link"));
const Icon_1 = __importDefault(require("../icon/Icon"));
const Logo_1 = __importDefault(require("../logo/Logo"));
exports.StyledAddress = (0, styles_1.styled)("div")({
    fontStyle: "inherit"
});
exports.Description = (0, styles_1.styled)("dd")({
    margin: 0
});
exports.Details = (0, styles_1.styled)("div")({
    overflow: "auto"
});
exports.Link = (0, styles_1.styled)(anchor_link_1.default)({
    fontFamily: "Effra Medium"
});
exports.List = (0, styles_1.styled)("dl")({
    marginTop: "0",
    marginBottom: "24px"
});
exports.RoofProLevelLogo = (0, styles_1.styled)(Logo_1.default)({
    height: "20px",
    verticalAlign: "text-bottom"
});
exports.Root = (0, styles_1.styled)("div")({
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
    width: "100%"
});
exports.Row = (0, styles_1.styled)("div")(({ theme }) => ({
    marginBottom: "12px",
    "&:last-of-type": {
        marginBottom: "0"
    },
    [theme.breakpoints.up("md")]: {
        marginBottom: "18px"
    },
    "& > dt": {
        marginBottom: "8px"
    }
}));
exports.AddressRow = (0, styles_1.styled)("div")(({ theme }) => ({
    marginBottom: "18px",
    "&:last-of-type": {
        marginBottom: "0"
    },
    [theme.breakpoints.up("md")]: {
        marginBottom: "24px"
    },
    "& > dt": {
        marginBottom: "8px"
    }
}));
exports.RoofProLevelRow = (0, styles_1.styled)("div")(({ theme }) => ({
    marginBottom: "12px",
    "&:last-of-type": {
        marginBottom: "0"
    },
    [theme.breakpoints.up("md")]: {
        marginBottom: "18px"
    },
    "& > dt": {
        marginBottom: "10px"
    }
}));
exports.Term = (0, styles_1.styled)("dt")({
    "&::after": {
        content: '":"'
    }
});
exports.Anchor = (0, styles_1.styled)(anchor_link_1.default)({
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    width: "42px",
    height: "42px"
});
exports.SocialMediaLinksRoot = (0, styles_1.styled)("ul")({
    alignItems: "start",
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0
});
exports.Item = (0, styles_1.styled)("li")({
    "&:last-child": {
        marginRight: 0
    }
});
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    fill: theme.colours.cyan500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px"
}));
//# sourceMappingURL=data:application/json;base64,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